import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { captureBackofficePageView, isPostHogReady } from '../analytics';
import { useConsent } from '../contexts/ConsentContext';

/**
 * Envoie un $pageview PostHog à chaque navigation SPA (backoffice authentifié ou public).
 */
const PostHogPageViews: React.FC = () => {
  useTranslation('common');
  const location = useLocation();
  const { consent } = useConsent();

  useEffect(() => {
    if (consent !== 'granted' || !isPostHogReady()) return;
    captureBackofficePageView(location.pathname, location.search);
  }, [consent, location.pathname, location.search]);

  return null;
};

export default PostHogPageViews;
